import { Entity, Periodicity } from '@ecosystem/newron-core/types';

export type MarketPeriod = {
  sequence: number;
  periodicity: Periodicity;
  name: string;
  value: string;
  published: string;
};

export type Market = Entity & {
  countryCode: string;
  countryName: string;
  productCode: string;
  productName: string;
  periods: MarketPeriod[];
  subscriptions: string;
};

export enum PeriodAggregation {
  Week = 'Week',
  Month = 'Month',
  Quarter = 'Quarter',
  RollingQuarter = 'RollingQuarter',
  Year = 'Year',
  Custom = 'Custom',
  MAT = 'MAT',
  YTD = 'YTD',
}

export type GroupedEntity = {
  label: string;
  options: Entity[];
};

export type TimeFrame = {
  periodicity: Periodicity;
  endSequence: number;
  startSequence?: number;
  aggregation: PeriodAggregation;
  label: string;
  value: string;
};

export type TimeFrameOption = TimeFrame & {
  availableOnAll: boolean;
};

export type CompetitorCheckBoxState = { topNCheckboxState: string; exactListCheckboxState: string };
